(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-meet-alison"] && !Shopify.designMode) return;
  try {
    

  $(document).ready(function() {
    $('.press .items img').each(function() {
      var width = $(this).width() / 2;
      //$(this).width(width);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-about"] && !Shopify.designMode) return;
  try {
    

  $(document).ready(function() {
    $('.press .items img').each(function() {
      var width = $(this).width() / 2;
      //$(this).width(width);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-header"]) return;
  try {
    
  
  // display mobile menu
  $('button.menu').click(function() {
    $(this).toggleClass('open');
    $('nav.mobile').toggleClass('active');
  });

  // display mobile sub nav
  $('nav.mobile ul button').click(function() {
    var handle = $(this).attr('data');
    var heightChild = $('ul.ul_' + handle).height();
    var heightParent = $('nav.mobile ul.parent').height();
    var difference = heightChild - heightParent;

    if(difference < 0) {
      difference = 0;
    }

    var paddingTop = (45 + difference) + 'px';
    $('nav.mobile .utility').css('padding-top',paddingTop);

    $('ul.parent').toggleClass('open');
    $('ul.ul_' + handle).toggleClass('active');
  });

  // display mobile search
  $('button.mobile_microsearch').click(function() {
    $(this).toggleClass('hide');
    $('button.close_mobile_microsearch').toggleClass('show');
    $('form.mobile-header-search').toggleClass('show');
    $('a.logo').toggleClass('hide');
    $('div.header_third').toggleClass('show_search');
  });

  // hide mobile search
  $('button.close_mobile_microsearch').click(function() {
    $(this).toggleClass('show');
    $('button.mobile_microsearch').toggleClass('hide');
    $('form.mobile-header-search').toggleClass('show');
    $('a.logo').toggleClass('hide');
    $('div.header_third').toggleClass('show_search');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-popup"]) return;
  try {
    

  // clear error fields
  $('.newsletter_email_popup').focus(function() {
    console.log('focus');
    $('.popup-errors').removeClass('active');
  });

  // display overlay
  function displayOverlay() {
    $('.overlay').addClass('active');
  }

  $('.header_newsletter_button').click(function() {
    displayOverlay();
  });

  // hide overlay
  function closeOverlay() {
    $('.overlay').removeClass('active');
  }

  $('.overlay .button-close button').click(function() {
    closeOverlay();
  });

  $(document).on('keydown', function(event) {
    if(event.key === "Escape") {
      closeOverlay();
    }
  });

  $('#shopify-section-theme-popup').on('click', function(event) {
    if ($(event.target).is('#overlay_newsletter, #overlay_newsletter *')) {
      //  Clicked element is within #overlay_newsletter
    } else {
      closeOverlay();
    }
  });


  } catch(e) { console.error(e); }
})();
})();
